import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAlertData, setNotificationOff } from "../../../redux/actions";

let interval;

function useNotifications(userType) {
  const alertData = useSelector((state) => state.alertReducer.alertData);
  const newNotification = useSelector(
    (state) => state.alertReducer.newNotification
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (userType !== "SA") {
      dispatch(getAlertData());

      const interval = window.setInterval(() => {
        dispatch(getAlertData());
      }, 60000);

      return () => {
        window.clearInterval(interval);
      };
    }
  }, [userType, dispatch]);

  const notificationToggle = () => {
    dispatch(setNotificationOff());
  };

  return { alertData, newNotification, notificationToggle };
}

export default useNotifications;
